// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2fZJb","description":"PatientConsentPreview_description__1JS1l"};